import React from 'react'
import PropTypes from 'prop-types'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import cn from 'classnames'

import { ReactComponent as IconSortable } from 'assets/icons/IconSortable.svg'

const ProductItem = ({ uuid, name }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: uuid })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      key={uuid}
    >
      <div
        className={cn('item -nested-item', {
          '-is-dragging': isDragging,
        })}
      >
        <div className="row">
          <div className="item-info-wrapper">
            <IconSortable className="item-info-wrapper__icon" />
            {name}
          </div>
        </div>
      </div>
    </div>
  )
}

ProductItem.propTypes = {
  name: PropTypes.string,
  uuid: PropTypes.string,
}

export default ProductItem
